module.exports = __webpack_public_path__ + "img/yczcfwImg.795c08f4.png";